import { ORDER_PAGE_FLAGS } from '@Orders/logic'
import { PROVISIONED_UI_FLAGS } from '@Builder/QuoteDetailPage/logic'

import { DefaultRootState } from '~/types'
import isFlagEnabled from '~/lib/isFlagEnabled'
import { getUserIdentity } from '~/redux-modules/identity'

export const selectFlags = (state: DefaultRootState) => {
    const identity = getUserIdentity(state)

    return {
        isReorderEnabled: isFlagEnabled(
            identity,
            ORDER_PAGE_FLAGS.REORDER,
            'true',
        ),
        isReorderInvalidConfigEnabled: isFlagEnabled(
            identity,
            ORDER_PAGE_FLAGS.INVALID_CONFIG_REORDER,
            'true',
        ),
        isNotifyIncotermsChangeEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.NOTIFY_INCOTERMS_CHANGE,
            'true',
        ),
        isImShipmentsEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.IM_SHIPMENTS_UI,
            'true',
        ),
        isImToolingEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.IM_TOOLING_UI,
            'true',
        ),
        isTransparencyImprovementEnabled: isFlagEnabled(
            identity,
            ORDER_PAGE_FLAGS.RELEASE_TRANSPARENCY_IMPROVEMENT,
            'true',
        ),
    }
}
